<template>
    <zen-message-modal :isOpen="isOpen" title="Remove segment?">
        Removing this segment will remove all contexts from the segment and the
        segment will no longer be referenced in targeting rules. Additionally,
        any data stored about this segment will be purged.
        <strong>This action is irreversible.</strong>
        <template v-slot:buttons>
            <zen-button variant="primary-danger" @click="$emit('confirm')">
                Remove
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RemoveSegmentModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
